export default "__VITE_ASSET__rtpMT0qk__"